import { render, staticRenderFns } from "./zuanti2.vue?vue&type=template&id=4ad92606&scoped=true&"
import script from "./zuanti2.vue?vue&type=script&lang=js&"
export * from "./zuanti2.vue?vue&type=script&lang=js&"
import style0 from "./zuanti2.vue?vue&type=style&index=0&id=4ad92606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad92606",
  null
  
)

export default component.exports